import React, {useState, useEffect, useRef} from 'react';
import PubSub from 'services/PubSub';
import CustomSelect from 'components/CustomSelect';
import WireTransferServices from 'services/WireTransfer';
import { typeAccount } from 'config';
import { actionsType } from 'config/constants';
import { elipsis } from 'utils/index';
import Loader from 'components/Loader';
import { useViewportMediaQuery } from 'hooks'
import style from './style.scss'

const ContentBankAccount = ({userInfo, closeRescheduleMessage}) => {
    const [typeAccountSelected, setTypeAccountSelected] = useState(null);
    const [listBank, setListBank] = useState(null);
    const [typeBankSelected, setTypeBankSelected] = useState(null);
    const [isvalid, setIsvalid] = useState(false);
    const [loading, setLoading] = useState(false);
    const isMobile = useViewportMediaQuery(371)

    let inputRef = useRef();

    useEffect(() => {
        _getListBank();
    }, [])

    const _typeAccount = (data) => {
        setTypeAccountSelected(data);
    }

    const _getListBank = () => {
        WireTransferServices.listBank().then(results => {
            if(!(results && results.banks)) return null;

            setListBank(results.banks.map(bank => {
                return {
                    label: bank.name,
                    value: bank.code
                }
            }));
        })
    }

    const _typeBank = (data) => {
        setTypeBankSelected(data);
    }

    const formIsValid = () => {
        const validInput = inputRef.current && inputRef.current.value;
        if(validInput.length > 3){
            setIsvalid(!!validInput)
        } else if(validInput.length <= 3) {
            setIsvalid(false)
        }
    }

    const accountSubmit = () => {
        setLoading(true);
        if(!(typeBankSelected.value && inputRef.current.value && typeAccountSelected.label)) return false;

        WireTransferServices.addAccount(typeBankSelected.value, inputRef.current.value, typeAccountSelected.label).then(data => {
            if(data.status === 200) {
                setLoading(false);
                closeRescheduleMessage();
                PubSub.dispatch(actionsType.GET_ACCOUNT_BANK_INFO, {data: data});
            }
        })
    }

    return(
        <div className={'new-modal-container'}>
            <div className={'new-modal-scroll'}>
                <span className="modal-bank-account-title">Datos para devolución de dinero</span>
                <p className="modal-bank-account-subtitle">Ingresa los datos de tu cuenta bancaria donde haremos las devoluciones de dinero en caso de haber diferencias a tu favor</p>
                <div className="modal-bank-account-user-info">
                    <div className="modal-bank-account-user-info-wrap">
                        <span className="modal-bank-account-user-info-title">Nombre titular</span>
                        <span className="modal-bank-account-user-info-data">{isMobile ? elipsis(userInfo.firstName + ' ' + userInfo.lastName, 20) : userInfo.firstName + ' ' + userInfo.lastName}</span>
                    </div>
                    <div className="modal-bank-account-user-info-wrap">
                        <span className="modal-bank-account-user-info-title">Mail</span>
                        <span className="modal-bank-account-user-info-data">{isMobile ? elipsis(userInfo.email, 20) : userInfo.email}</span>
                    </div>
                </div>
                <div className="modal-bank-account-data-wrap">
                    <div className="modal-bank-account-data">
                        <span className="modal-bank-account-data-title">Banco</span>
                        <CustomSelect placeholder="Selecciona un banco" options={listBank} onChange={_typeBank} value={typeBankSelected}/>
                    </div>
                    <div className="modal-bank-account-data">
                        <span className="modal-bank-account-data-title">Tipo de cuenta</span>
                        <CustomSelect placeholder="Selecciona un tipo de cuenta" options={typeAccount} onChange={_typeAccount} value={typeAccountSelected}/>
                    </div>
                    <div className="modal-bank-account-data">
                        <span className="modal-bank-account-data-title">Número cuenta</span>
                        <input className="modal-bank-account-input" type="number" ref={inputRef} onChange={formIsValid}/>
                    </div>
                </div>
            </div>
            <div className={'modal-actions'}>
                <button className="secundary-btn" onClick={closeRescheduleMessage}>Hacerlo después</button>
                <button className={(typeBankSelected && typeAccountSelected && isvalid ? ' primary-btn ' : ' disabled-btn ')} onClick={accountSubmit}>
                    {loading && <div className="modal-bank-btn-loader"><Loader /></div>}
                    {!loading && <span>Guardar</span>}
                </button>
            </div>
        </div>
    )
}

export default ContentBankAccount;